// extracted by mini-css-extract-plugin
module.exports = {"app__header":"bl_fG","app__footer":"bl_5","app__flex_row":"bl_fH","app__content__list":"bl_fJ"};